<partners-selector
  [config]="config"
  [selected]="selected"
  (selectedChange)="update($event)"
></partners-selector>
